import { useState } from "react";

const FeedbackWizard = ({ onSubmit, apartmentName }) => {
  const steps = [
    { key: "cleanliness", label: "Cleanliness" },
    { key: "location", label: "Location" },
    { key: "value", label: "Value for money" },
    { key: "comfort", label: "Comfort" },
  ];

  const [stepIndex, setStepIndex] = useState(0);
  const [ratings, setRatings] = useState({ cleanliness: 8, location: 8, value: 8, comfort: 8 });
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  const step = steps[stepIndex];
  const isLastStep = stepIndex === steps.length - 1;
  const progress = ((stepIndex + 1) / steps.length) * 100;

  const handleSelect = async (value) => {
    setRatings((prev) => ({ ...prev, [step.key]: value }));

    if (!isLastStep) {
      setTimeout(() => setStepIndex((i) => i + 1), 180);
      return;
    }
  };

  const handleSubmit = async () => {
    setSaving(true);
    await onSubmit({ ...ratings, comment });
    setSaving(false);
    setDone(true);
  };

  if (done)
    return (
      <div className="bg-green-50 border border-green-200 rounded-2xl p-6 text-center animate-fadeIn">
        <p className="text-2xl">🎉</p>
        <h3 className="font-bold text-green-800 text-lg mt-2">Thank you for your feedback!</h3>
      </div>
    );

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 space-y-6">
      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase">Guest feedback</p>
        <h3 className="text-lg font-bold text-slate-900">
          Rate your stay{apartmentName ? ` · ${apartmentName}` : ""}
        </h3>
      </div>

      {/* Progress bar */}
      <div className="w-full h-1 bg-slate-200 rounded-full overflow-hidden">
        <div className="h-full bg-[#3a2a00] transition-all duration-300" style={{ width: `${progress}%` }} />
      </div>

      {/* Rating step */}
      <div className="border rounded-xl p-4">
        <p className="font-semibold text-slate-900 mb-2">{step.label}</p>
        <div className="flex justify-between">
          {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
            <button
              key={n}
              onClick={() => handleSelect(n)}
              className={`w-9 h-9 rounded-full text-sm font-bold border transition-all ${
                ratings[step.key] === n
                  ? "bg-[#3a2a00] text-white border-[#3a2a00] scale-110"
                  : "border-slate-300 text-slate-600"
              }`}
            >
              {n}
            </button>
          ))}
        </div>
      </div>

      {isLastStep && (
        <>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Optional comment"
            className="w-full min-h-[90px] border rounded-xl p-3 text-sm"
          />
          <button
            onClick={handleSubmit}
            disabled={saving}
            className="w-full py-4 bg-[#3a2a00] text-white rounded-xl font-bold"
          >
            {saving ? "Submitting…" : "Submit Review"}
          </button>
        </>
      )}
    </div>
  );
};

export default FeedbackWizard;
